<div class="lm-module-facade-bc-wrapper">
  <div class="lm-module-facade-bc-title">
    <soho-toolbar-flex>
      <soho-toolbar-flex-section>
        <button
          soho-button="icon"
          id="lm-close-module-facade-bc"
          data-automation-id="lm-close-module-facade-bc"
          class="btn-icon application-menu-trigger"
          [icon]="'arrow-left'"
          lm-tooltip [content]="'Close' | translate"
          (click)="closeBOExplorer()">
        </button>
      </soho-toolbar-flex-section>
      <soho-toolbar-flex-section isTitle="true">
        <span
          attr.id="lm-module-facade-bc-title"
          attr.data-automation-id="lm-module-facade-bc-title"
          class="lm-bc-title lm-bold"
          lm-tooltip content="{{businessObject.title}}"
        >{{businessObject.title}}</span>
      </soho-toolbar-flex-section>
    </soho-toolbar-flex>
  </div>
  <div class="lm-module-facade-bc-details">
    <div class="lm-module-facade-bc-detail-wrapper">
      <p class="lm-module-facade-bc-detail-label lm-bold">{{ 'BusinessClass' | translate }}</p>
      <p class="lm-module-facade-bc-detail-value" [attr.id]="'lm-module-facade-bc-detail-business-class'"
      >{{businessObject.businessClass}}</p>
      <div class="tag lm-facade-tile" [ngClass]="color()"><span>{{ businessObject.category }}</span></div>
    </div>
<!--    <div class="lm-module-facade-bc-detail-wrapper">-->
<!--      <p class="lm-module-facade-bc-detail-label lm-bold">{{ 'ReportCatalogCategory' | translate }}</p>-->
<!--      <p class="lm-module-facade-bc-detail-value" [attr.id]="'lm-module-facade-bc-detail-category'"-->
<!--      >{{businessObject.category}}<svg soho-icon [icon]="'edit'" class="lm-module-facade-bc-edit-icon" (click)="onEditCategory()"/></p>-->
<!--    </div>-->
    <div class="lm-module-facade-bc-detail-wrapper">
      <p class="lm-module-facade-bc-description font-size-sm" [attr.id]="'lm-module-facade-bc-description'"
      >{{businessObject.description}}</p>
    </div>
  </div>
  <div class="lm-module-facade-bc-content scrollable">
    <div class="lm-module-facade-bc-types">
      <div class="lm-module-facade-bc-report-types">
        <div class="lm-card-content">
          <p class="section-title lm-card-section-title lm-bold">{{ 'Facade_BusinessObjectReportType' | translate }}</p>
        </div>
        <div class="lm-module-facade-bc-report-types-data">
          @for (option of reportTypes; track option.title) {
            <div class="lm-card-view {{ option.type}}"
                 [class.lm-card-selected]="option.type === selectedReportType"
                 (click)="onReportTypeClick(option.type)">
              <div class="lm-card-content">
                  <div class="lm-card-image">
                      <span><svg soho-icon [icon]="option.icon"/></span>
                  </div>
                  <div class="lm-card-title" soho-tooltip [content]="option.title">
                  <span><p class="lm-bold">{{ option.title }}</p></span>
                </div>
                <p class="lm-card-description" soho-tooltip [content]="option.description">{{ option.description }}</p>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="lm-module-facade-bc-templates">
      <div class="lm-card-content">
        <p class="section-title lm-card-section-title lm-bold">{{ 'Facade_BusinessObjectCopyExistingReport' | translate : businessObject.title }}</p>
      </div>
      <div class="lm-module-facade-bc-templates-filter-shortcut-wrapper">
        <div class="lm-module-facade-bc-templates-quick-filters">
          @for (filter of quickFilter; track filter.option) {
            <div class="tag-container">
              <span
                class="tag"
                [class.selected-tab]="filter.option === selectedReportFilter"
                (click)="onQuickFilterClick(filter.option)"
              >{{ filter.displayName }}</span>
            </div>
          }
        </div>
        <lm-facade-toggle-button (toggleButtonClicked)="viewClicked($event)"></lm-facade-toggle-button>
      </div>
        @if (viewTilesSelected) {
          <div class="lm-module-facade-bc-report-template-data" [class.no-templates]="displayedTemplates.length === 0">
            @for (template of displayedTemplates; track template.reportName) {
              <lm-facade-tile
                [title]="template.reportName"
                [description]="template.description"
                [template]="template"
                [owner]="template.owner.length > 0 ? template.owner : 'Infor '"
                [selected]="template === selectedTemplate"
                [cardWidth]="moduleCardWidth()"
                (templateClicked)="onTemplateClicked($event)"
              ></lm-facade-tile>
            } @empty {
                <div soho-emptymessage [title]="emptySearchTitle" [info]="emptySearchInfo" [icon]="'icon-empty-search-data-new'"></div>
            }
          </div>
        } @else {
          <div class="lm-facade-data-grid-wrapper">
            <div soho-datagrid
                 data-automation-id="lm-field-picker-data-grid"
                 class="lm-facade-field-picker-data-grid"
                 [gridOptions]="templateGridOptions"
                 [data]="displayedTemplates"
                 (rowClicked)="onRowClicked($event)">
            </div>
          </div>
        }
    </div>
  </div>
</div>
@if (facadeDetailRequest().type === 'businessClass') {
    <lm-facade-business-class-detail [businessClassDetail]="facadeDetailRequest().detail"></lm-facade-business-class-detail>
} @else if (facadeDetailRequest().type === 'template') {
    <lm-facade-report-template-detail [reportTemplateDetail]="facadeDetailRequest().detail"></lm-facade-report-template-detail>
} @else {
    <lm-facade-unknown-detail [request]="facadeDetailRequest()"></lm-facade-unknown-detail>
}
